import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {UIError} from 'common/interfaces';
import {ITaxState, ITax} from 'common/interfaces/istore';

const initialState: ITaxState = {
  loading: false,
  error: null,
  allTaxes: null,
  currentStoreTax: null,
  updated: false,
} as ITaxState;

const reducers = {
  setLoading: (state: ITaxState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: ITaxState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: ITaxState) => {
    state = initialState;
  },
  setAllTaxes: (state: ITaxState, action: PayloadAction<ITax[] | null>) => {
    console.log('Setting tax list in redux.....', action.payload);
    state.allTaxes = action.payload;
  },

  setStoreTax: (state: ITaxState, action: PayloadAction<ITax | null>) => {
    state.currentStoreTax = action.payload;
  },
  setUpdated: (state: ITaxState, action: PayloadAction<boolean>) => {
    state.updated = action.payload;
  },
};

const taxSlice = createSlice({
  name: 'ITaxState',
  initialState: initialState,
  reducers: reducers,
});

export default taxSlice.reducer;
export const TaxActions = taxSlice.actions;
